import * as busyCounter from '../../../shared/action-creators/busy-counter';
import {getFileName} from '../../../shared/services/get-file-name';
import {openFile} from '../../../shared/services/open-file';
import {postRgaUpload} from '../../shared/repositories';
import {successAlertBar} from '../../../shared/services/alert-bar';
import {translate} from '../../../shared/services/translation-service';

export const uploadRgaExcel = file =>

        async dispatch => {

            dispatch(busyCounter.increaseBusyCounter());

            try {

                const response = await postRgaUpload(file);

                const fileName = getFileName(response);

                const blob = await response.blob();

                openFile(blob, fileName, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');

                successAlertBar(translate('Upload successful. Check the report for created RGAs and any errors.'));

            } catch (error) {
            } finally {

                dispatch(busyCounter.decreaseBusyCounter());

            }

        };



// WEBPACK FOOTER //
// ./src/rga/mass-upload/action-creators/rga-upload.js